<template>
  <div>
    <v-dialog v-model="isOpen" max-width="720" persistent>
      <v-card>
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <h1>{{ cardTitle }}</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text v-if="isLoading" class="py-12 d-flex align-center justify-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-card-text>
        <v-card-text v-else class="py-4">
          <v-row>
            <v-col cols="12" md="6" class="pb-0">
              <v-autocomplete
                label="Nome do Embarcador"
                v-model="aditional.senderId"
                :items="senders"
                item-text="name"
                item-value="id"
                :readonly="shouldDisableEdit"
                :disabled="shouldDisableEdit"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
              <v-select
                label="Tipo"
                v-model="aditional.isDiscount"
                :items="aditionalType"
                :readonly="shouldDisableEdit"
                :disabled="shouldDisableEdit"
                :rules="[rules.aditionalType]"
                @input="onIsDiscountChange"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" sm="7" class="pb-0">
              <v-select
                label="Justificativa"
                v-model="aditional.justificationId"
                :items="justifications"
                item-text="name"
                item-value="id"
                :readonly="shouldDisableEdit"
                :disabled="shouldDisableEdit"
                :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" sm="5" class="pb-0">
              <v-text-field
                label="Valor"
                v-model="aditional.price"
                v-money="money"
                type="text"
                :readonly="shouldDisableEdit"
                :disabled="shouldDisableEdit"
                :rules="[rules.hasPrice]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="7" class="pb-0">
              <v-text-field
                label="Chave da CTE"
                v-model="aditional.accessKeyCte"
                v-mask="'############################################'"
                type="text"
                :readonly="shouldDisableEdit"
                :disabled="shouldDisableEdit"
                :rules="[rules.required]"
                :error-messages="validateKeyCteRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="5" class="pb-0">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedDate"
                    label="Data"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :disabled="shouldDisableEdit"
                    :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :readonly="shouldDisableEdit"
                  :disabled="shouldDisableEdit"
                  v-model="aditional.additionalDate"
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-file-input
                v-if="hasFileImport || shouldDisableEdit"
                v-model="documentImportXml"
                disabled
                class="file-input-disable"
                :class="{ 'no-file': !hasFileImport && shouldDisableEdit }"
                accept=".xml, text/xml"
                :label="documentImportXml ? 'Arquivo XML: ' : 'Sem Arquivo XML'"
                hide-details
              >
                <template v-slot:append>
                  <div class="btn-file" v-if="hasFileImport">
                    <v-menu
                      v-model="menu2"
                      v-if="!shouldDisableEdit"
                      :close-on-content-click="false"
                      :nudge-width="100"
                      nudge-left="100"
                      nudge-top="15"
                      top
                      offset-y
                    >
                      <template v-slot:activator="{ on: menu1, attrs }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              :loading="isDeleteFileLoading"
                              v-bind="attrs"
                              v-on="{ ...tooltip, ...menu1 }"
                              icon
                              color="red"
                            >
                              <v-icon dark> mdi-delete </v-icon>
                            </v-btn>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </template>

                      <v-card>
                        <v-card-title>
                          <span class="mx-auto my-0 pb-0 text-body-1"> Deletar XML? </span>
                        </v-card-title>

                        <v-card-actions class="d-flex justify-center">
                          <v-btn small text @click="menu2 = false"> Cancelar </v-btn>
                          <v-btn small color="error" text @click="(menu2 = false), deleteFileXml()"> Deletar </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          icon
                          :loading="isDownloadFileLoading"
                          @click="downloadFileXml()"
                        >
                          <v-icon dark>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Download</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-file-input>
              <v-file-input
                v-if="!shouldDisableEdit && !hasFileImport"
                v-model="file"
                class="file-input"
                accept=".xml, text/xml"
                :label="file ? 'Arquivo Selecionado: ' : 'Importar Arquivo XML'"
                hide-details
              >
              </v-file-input>
            </v-col>
            <v-col cols="12" class="pb-0">
              <v-textarea
                v-model="aditional.observation"
                :readonly="shouldDisableEdit"
                :disabled="shouldDisableEdit"
                label="Observação"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center py-4" style="gap: 5px">
          <v-btn v-if="!shouldDisableEdit" @click="close" color="red" dark class="px-4"> Cancelar </v-btn>
          <v-btn
            v-if="!shouldDisableEdit"
            @click="handleAditionalEdition"
            :loading="isEditButtonLoading"
            :disabled="shouldDisableEditButton"
            :dark="!shouldDisableEditButton"
            color="green"
            class="px-4"
          >
            Confirmar
          </v-btn>
          <v-btn v-if="shouldDisableEdit" @click="close" class="flex-grow-1" color="info"> Voltar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError
      :errors="errors"
      :type="errorsType"
      :error500="error500"
      @closeMessages="(errors = []), (validateKeyCte = null)"
    />
  </div>
</template>
<script>
import { VMoney } from 'v-money';
import { mapActions } from 'vuex';
import MessagesError from '@/components/MessagesError.vue';
import Base64Mixin from '@/mixins/base64.mixin';

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    aditionalToEdit: {
      default: () => ({
        id: null,
        senderId: null,
        isDiscount: null,
        price: null,
        additionalDate: null,
        accessKeyCte: null,
        observation: null,
        invoiceId: null,
        xmlFileName: null
      }),
      type: Object
    }
  },
  components: {
    MessagesError
  },
  mixins: [Base64Mixin],
  directives: { money: VMoney },
  data: () => ({
    isLoading: false,
    isEditButtonLoading: false,
    isDeleteFileLoading: false,
    isDownloadFileLoading: false,
    menu: false,
    menu2: false,
    aditional: {
      id: null,
      senderId: null,
      isDiscount: null,
      price: null,
      justificationId: null,
      additionalDate: null,
      accessKeyCte: null,
      observation: null,
      invoiceId: null,
      documentImportXml: null
    },
    file: null,
    documentImportXml: null,
    hasFileImport: false,
    aditionalType: [
      { text: 'Crédito', value: false },
      { text: 'Débito', value: true }
    ],
    senders: [],
    justifications: [],
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    rules: {
      required: (value) => !!value || 'Campo obrigatório!',
      aditionalType: (value) => value !== null || 'Campo obrigatório!',
      hasPrice: (value) => {
        return value !== 'R$ 0,00' || 'Campo obrigatório!';
      }
    },
    validateKeyCte: null,
    errors: [],
    errorsType: 'error',
    error500: null
  }),

  computed: {
    cardTitle() {
      return `${this.hasInvoiceReceivable ? 'Visualizar' : 'Editar'} adicional`;
    },

    formattedDate() {
      const date = this.aditional.additionalDate;
      if (date === null) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    shouldDisableEditButton() {
      if (this.aditional.justificationId === null) return true;
      const { senderId, isDiscount, price, accessKeyCte, additionalDate, justificationId } = this.aditional;
      return (
        !senderId ||
        isDiscount === null ||
        this.transformPriceToSend(price) === 0 ||
        !accessKeyCte ||
        additionalDate === null ||
        !justificationId
      );
    },

    hasInvoiceReceivable() {
      return this.aditional.invoiceId && this.aditional.invoiceId !== '00000000-0000-0000-0000-000000000000';
    },

    shouldDisableEdit() {
      return this.hasInvoiceReceivable;
    },

    validateKeyCteRules() {
      if (!this.validateKeyCte && this.validateKeyCte !== null) {
        const error = 'Chave da CTE não pertence ao embarcador ou não foi encontrado';
        return error;
      }
      return null;
    }
  },

  watch: {
    isOpen: {
      async handler(isOpen) {
        if (isOpen) {
          this.isLoading = true;

          const {
            id,
            nameSender,
            isDiscount,
            price,
            justification,
            additionalDate: dateToFormat,
            accessKeyCte,
            observation,
            invoiceId,
            xmlFileName
          } = this.aditionalToEdit;

          const additionalDate = dateToFormat.slice(0, 10);

          await this.getAllSenders();
          const senderId = this.setSender(nameSender);

          await this.getJustifications(isDiscount);
          const justificationId = await this.setJustification(justification);

          if (xmlFileName) {
            this.documentImportXml = { name: xmlFileName };
            this.hasFileImport = true;
          }

          this.aditional = {
            id,
            senderId,
            isDiscount,
            price: Number((price * 100).toFixed(2)),
            justificationId,
            additionalDate,
            accessKeyCte,
            observation,
            invoiceId
          };
          this.isLoading = false;
        }
      }
    },
    'aditional.isDiscount': {
      handler(isDiscount, oldIsDiscount) {
        if (oldIsDiscount !== null) {
          this.getJustifications(isDiscount);
        }
      }
    }
  },

  methods: {
    ...mapActions('AccountsReceivableStore', [
      'editAditional',
      'getSenders',
      'validateAccessKeyCte',
      'downloadXmlAditional',
      'deleteXmlAditional'
    ]),
    ...mapActions('NfeStore', ['fetchJustificationsById']),

    async handleAditionalEdition() {
      try {
        this.isEditButtonLoading = true;
        this.validateKeyCte = await this.isValidateKeyCte(this.aditional);
        if (this.validateKeyCte) {
          if (this.file) {
            const dataFiles = await this.toBase64(this.file);
            this.aditional.documentImportXml = {
              fileName: this.file.name,
              dataFiles: dataFiles.split('base64,')[1]
            };
          }

          const { price } = this.aditional;
          const aditionalEdit = {
            ...this.aditional,
            price: this.transformPriceToSend(price)
          };

          const data = await this.editAditional(aditionalEdit);
          if (data.success) {
            this.handleSuccessFeedback();
          } else {
            this.errors = data.errors;
            this.errorsType = 'error';
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isEditButtonLoading = false;
      }
    },

    async getAllSenders() {
      try {
        this.senders = await this.getSenders();
      } catch (error) {
        console.error(error);
      }
    },

    async getJustifications(isAditionalDiscount = false) {
      const justificationsNumber = isAditionalDiscount ? 13 : 12;
      try {
        this.justifications = await this.fetchJustificationsById(justificationsNumber);
      } catch (error) {
        console.error(error);
      }
    },

    setSender(senderName) {
      return this.senders.find((item) => item.name == senderName).id;
    },

    setJustification(justification) {
      return this.justifications.find((item) => item.name == justification).id;
    },

    async isValidateKeyCte(aditional) {
      const params = {
        senderId: aditional.senderId,
        accessKeyCte: aditional.accessKeyCte
      };
      const validationResult = await this.validateAccessKeyCte(params);
      if (validationResult.success) {
        return true;
      }

      this.errors = validationResult.errors;
      this.errorsType = 'error';
      setTimeout(() => {
        this.errors = [];
        this.validateKeyCte = null;
      }, 5000);
      return false;
    },

    async deleteFileXml() {
      try {
        this.isDeleteFileLoading = true;

        const data = await this.deleteXmlAditional(this.aditional.id);
        if (data.success) {
          this.hasFileImport = false;
          this.handleDeleteFileFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (e) {
        console.error(e);
        this.errors = e.errors;
        this.errorsType = 'error';
      } finally {
        this.isDeleteFileLoading = false;
      }
    },

    async downloadFileXml() {
      try {
        this.isDownloadFileLoading = true;

        const data = await this.downloadXmlAditional(this.aditional.id);
        if (!data.success) {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (e) {
        console.error(e);
        this.errors = e.errors;
        this.errorsType = 'error';
      } finally {
        this.isDownloadFileLoading = false;
      }
    },

    handleSuccessFeedback() {
      this.errors = ['Adicional editado com sucesso!'];
      this.errorsType = 'success';
      this.$emit('shouldUpdateList');
      this.close();
      this.setClearErrorTimer();
    },

    handleDeleteFileFeedback() {
      this.errors = ['Arquivo xml deletado com sucesso!'];
      this.errorsType = 'success';
      this.$emit('shouldUpdateList');
      this.setClearErrorTimer();
    },

    setClearErrorTimer() {
      setTimeout(() => {
        this.errors = [];
      }, 3000);
    },

    close() {
      this.$emit('update:isOpen', false);
      this.file = null;
      this.documentImportXml = null;
      this.hasFileImport = false;
    },

    onIsDiscountChange() {
      this.aditional.justificationId = null;
    },

    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep.v-input__slot {
  margin: 0;
  padding: 0;

  &::after,
  &::before {
    display: none !important;
  }
}

::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 4px;
      display: inline-block;
    }
  }
}

::v-deep .v-file-input__text {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  top: -6px !important;
  position: relative !important;
  left: 145px !important;
  width: auto !important;
}

::v-deep .file-input-disable {
  padding-top: 1px;
  height: 47.2px;
  cursor: default;

  * {
    cursor: default;
  }

  .v-text-field__slot .v-label {
    top: 7px;
  }

  .v-input__prepend-outer {
    position: relative !important;
    top: 6px !important;
    left: 8px !important;
  }

  .v-input__append-inner {
    margin-top: 0px;
  }
  .v-input__append-inner .btn-file {
    margin: 5px 10px 2px 0;
    * {
      cursor: pointer;
    }
  }
}

::v-deep .no-file {
  .v-text-field__slot .v-label {
    top: 12px;
  }
}

.file-input-disable ::v-deep .v-file-input__text {
  left: 95px !important;
  top: 1px !important;
}

::v-deep .v-select__slot .v-input__append-inner.v-input__append-inner .v-input__icon--clear {
  padding-top: 17px;
}
::v-deep .theme--light.v-file-input.v-input--is-disabled .v-file-input__text {
  color: #1e1e1e;
}
.file-input ::v-deep .v-input__append-inner.v-input__append-inner .v-input__icon--clear {
  margin-right: 10px;
  margin-top: -5px;
}

::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}
</style>
